require("facility/main")

// カスタムマルチセレクト
import "../../custom_multiselect"